var _circle, _path, _path2, _ellipse, _circle2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterpersonalSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5112,
    cy: 59.2557,
    r: 18.6608,
    transform: "rotate(-173.065 72.5112 59.2557)",
    fill: "#FF7700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2 50.052C66.1036 50.8442 65.5014 51.4236 64.8558 51.345C64.2103 51.2665 63.7645 50.5597 63.8609 49.7674C63.9572 48.9752 64.5595 48.3958 65.205 48.4744C65.8506 48.5529 66.2963 49.2597 66.2 50.052Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5392 50.4207C71.4362 51.2676 70.7821 51.8857 70.0794 51.8002C69.3767 51.7147 68.8899 50.9579 68.9929 50.111C69.096 49.2641 69.75 48.646 70.4527 48.7314C71.1554 48.8169 71.6422 49.5738 71.5392 50.4207Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.82211,
    cy: 2.27764,
    rx: 1.82211,
    ry: 2.27764,
    transform: "matrix(-0.991362 -0.131156 -0.131156 0.991362 69.4209 52.335)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7015,
    cy: 21.7015,
    r: 21.7015,
    transform: "matrix(0.99269 -0.120695 -0.120695 -0.99269 6.23828 83.5889)",
    fill: "#FFD100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5021 48.7228C32.6141 49.6442 33.3145 50.318 34.0652 50.2267C34.816 50.1354 35.3344 49.3135 35.2224 48.3921C35.1104 47.4707 34.4101 46.797 33.6593 46.8883C32.9086 46.9795 32.3901 47.8015 32.5021 48.7228Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2918 49.1521C26.4116 50.137 27.1721 50.8559 27.9894 50.7565C28.8066 50.6571 29.3727 49.777 29.253 48.7921C29.1332 47.8071 28.3727 47.0883 27.5554 47.1877C26.7382 47.287 26.1721 48.1672 26.2918 49.1521Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1266 54.0187C30.7523 54.8967 33.0064 55.118 34.0093 53.2293C34.3965 52.4991 33.2433 51.9384 32.8538 52.6675C32.2036 53.8908 30.6299 53.3735 29.6849 52.8644C28.9582 52.4702 28.3987 53.6268 29.1242 54.0175",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6577 38.2963C45.0313 36.5302 39.1426 29.7039 40.5051 23.0492C41.8675 16.3945 46.6165 11.746 58.5914 14.1977C70.5664 16.6494 73.1065 22.7902 71.7441 29.4448C70.937 33.3869 67.7665 36.3844 63.5226 37.806L63.0374 40.1762C62.9984 40.3668 62.7537 40.4239 62.6344 40.2702L61.1877 38.407C58.8418 38.8406 56.274 38.832 53.6577 38.2963Z",
    fill: "#93969B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterpersonalSkills);
export default __webpack_public_path__ + "static/media/interpersonal_skills.7ac20f043ceb8ebbf1527357074e12b4.svg";
export { ForwardRef as ReactComponent };